require('./default-menu.component');
require('./slide-menu.component');
require('./desktop-menu.component');
